import React from 'react';
import { TONE_BADGE } from '../utils/statusColors';

/**
 * O aviso de grupo econômico que não carregou, em Assinaturas e Faturas (07/10/2026). Ver hooks/useGruposEconomicos.
 *
 * Sem ele, a matriz cuja leitura falhava fazia as empresas do grupo aparecerem como avulsas: sem a linha que soma e
 * sem o percentual do compartilhado, a lista mostrava uma estrutura societária que não é a real, e nada dizia isso.
 * O aviso nomeia o grupo e diz o que a tela está mostrando no lugar dele.
 */
interface Props {
  grupos: Array<{ nome: string; avulsas: boolean }>;
  erro: string | null;
  onTentarDeNovo: () => void;
}

export default function AvisoDosGruposEconomicos({ grupos, erro, onTentarDeNovo }: Props) {
  if (grupos.length === 0) return null;
  const avulsas = grupos.filter((g) => g.avulsas).map((g) => g.nome);
  const antigas = grupos.filter((g) => !g.avulsas).map((g) => g.nome);
  const lista = (nomes: string[]) => nomes.join(', ');
  return (
    <div role="alert" className={`px-4 py-2.5 rounded-lg border border-amber-600/50 text-xs ${TONE_BADGE.warning}`} data-grupos-que-faltaram={grupos.length}>
      {avulsas.length > 0 && (
        <div>
          O rateio {avulsas.length === 1 ? 'do grupo econômico' : 'dos grupos econômicos'} <b>{lista(avulsas)}</b> não
          carregou{erro ? ` (${erro})` : ''}. As empresas {avulsas.length === 1 ? 'dele' : 'deles'} aparecem abaixo como
          avulsas, sem a linha do grupo e sem o percentual do compartilhado: isso não quer dizer que saíram do grupo.
        </div>
      )}
      {antigas.length > 0 && (
        <div className={avulsas.length > 0 ? 'mt-1' : ''}>
          O rateio {antigas.length === 1 ? 'do grupo econômico' : 'dos grupos econômicos'} <b>{lista(antigas)}</b> não
          atualizou{erro ? ` (${erro})` : ''}: o que aparece abaixo é da última leitura que deu certo.
        </div>
      )}
      <button
        type="button"
        onClick={onTentarDeNovo}
        className="mt-2 px-2.5 py-1 rounded bg-slate-700 hover:bg-slate-600 text-slate-100 text-xs font-medium"
      >
        Tentar de novo
      </button>
    </div>
  );
}
